// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 635) return "static/css/635.48fd99788df4933b20b8.lib.css";
	if (chunkId === 639) return "static/css/639.e9b6233ec5ee3282d6a9.css";
	// return url for filenames based on template
	return undefined;
};